var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline" },
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "data-label", class: { regular: _vm.regularLabel } },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "custom-time-picker-container",
          class: [_vm.classContainer, _vm.error ? "invalidated" : ""]
        },
        [
          _c("em", { class: _vm.getTimeViewIcon }),
          _c("div", { staticClass: "dropdown" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueFormatted,
                  expression: "valueFormatted"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "dropDownTimeSelector",
                "aria-expanded": "false",
                "aria-haspopup": "true",
                "data-toggle": "dropdown",
                disabled: _vm.disabled,
                placeholder: _vm.placeholder,
                readonly: "",
                type: "text"
              },
              domProps: { value: _vm.valueFormatted },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.valueFormatted = $event.target.value
                }
              }
            }),
            _vm.evalClearValue
              ? _c(
                  "span",
                  {
                    staticClass: "clear-time",
                    on: { click: _vm.onClearValue }
                  },
                  [_c("em", { staticClass: "fa fa-times" })]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "dropdown-menu no-border dropdown-menu-right custom-dropdown-menu",
                class: { "menu-right": _vm.isMenuRight },
                attrs: {
                  "aria-labelledby": "dropDownTimeSelector",
                  role: "menu"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "time-container" },
                  _vm._l(_vm.timeArray, function(group, groupIndex) {
                    return _c(
                      "div",
                      {
                        key: "time-group" + groupIndex,
                        staticClass: "time-container__time-row"
                      },
                      _vm._l(group, function(time, timeIndex) {
                        return _c(
                          "div",
                          {
                            key: "time-block" + timeIndex,
                            staticClass: "time-container__time-hour",
                            class: [
                              { active: _vm.evalSelectedHour(time.value) }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.onSelectTime(time)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(time.name))])]
                        )
                      }),
                      0
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ]
      ),
      _vm.error
        ? _c("error", {
            attrs: { message: _vm.customErrorMsg, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }